import Phaser from 'phaser'
import { GAME } from '../../env'
import { hitz } from '../../hitz'
import { HitzBlocked } from '@hitz/sdk'
import { BootScene } from './scenes/BootScene'
import { MenuScene } from './scenes/MenuScene'
import { GameScene } from './scenes/GameScene'
import { ResultScene } from './scenes/ResultScene'
import { exposeSmoke } from '../../testing'
import { THEME } from '../../kit/theme'

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: THEME.colors.bg,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME.size.width,
    height: GAME.size.height
  },
  render: { pixelArt: false, antialias: true },
  // Keep game time close to real time on slow devices: honour frame gaps up to 500 ms instead of clamping.
  fps: { min: 2, smoothStep: false },
  scene: [BootScene, MenuScene, GameScene, ResultScene]
})

// Pause when the tab is hidden. The SDK reports it to the host (action pause + attempt.suspended) by itself.
document.addEventListener('visibilitychange', () => (document.hidden ? game.loop.sleep() : game.loop.wake()))
hitz.init().then(() => game.events.emit('hitz-ready')).catch((err: unknown) => {
  // Published build opened by its direct URL, or a host outside the allow-list: minimal blocked screen, no gameplay (spec §2.3).
  game.registry.set('hitz-blocked', err instanceof HitzBlocked ? err.message : String(err))
})

// Dev-only handle for debugging in the console and for tests (never in production builds).
if (import.meta.env.DEV) (window as unknown as { __phaser: Phaser.Game }).__phaser = game

exposeSmoke({
  // Only between attempts: the host must finalize the previous attempt before a new one is requested.
  play: () => { if (!hitz.attempt) game.scene.getScenes(true).forEach((s) => s.scene.start('Game', { levelId: '1' })) },
  move: () => game.scene.getScene('Game')?.events.emit('smoke-move'),
  target: () => (game.scene.getScene('Game') as GameScene | undefined)?.target() ?? null,
  exit: () => hitz.exit()
})
